<script>
import CandidateQualificationListItem from './candidate-qualification-list-item.vue'

export default {
  name: 'CandidateDetailsQualifications',
  components: { CandidateQualificationListItem },
  props: {
    candidate: {
      type: Object,
      default: null,
    },
  },
  computed: {
    qualifications() {
      return this.candidate?.qualifications ?? []
    },
  },
}
</script>

<template>
  <div class="candidate-qualifications">
    <template v-if="qualifications.length">
      <CandidateQualificationListItem
        v-for="(qualification, index) in qualifications"
        :key="`${qualification.degree}-${qualification.institute}-${index}`"
        class="mb-2"
        :qualification="qualification"
        :time-zone="candidate.timeZone"
      />
    </template>
    <div v-else class="text-body-2 text--secondary py-2">
      {{ $t('candidateDetailsPopup.details.noQualifications') }}
    </div>
  </div>
</template>
